import React, { useEffect } from 'react';
import { StyledAppTab } from './StyledTabs';

const ApplicationTab = ({ id, selected, children }) => {
  useEffect(() => {
    const targetNode = document.getElementById(id);
    const config = { attributes: true, childList: false, subtree: false };

    const callback = function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          window.dispatchEvent(
            new CustomEvent('TAB_APP_VISIBILITY_CHANGED', {
              detail: {
                id,
                visible: mutation.target.classList.contains('hx-tab__selected'),
              },
            })
          );
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, [id]);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('TAB_APP_SELECTED_ON_CHANGE', {
        detail: {
          id,
          selected,
        },
      })
    );
  }, [selected, id]);

  return (
    <StyledAppTab
      id={id}
      selected={selected}
      className={selected ? 'hx-tab__selected' : ''}
    >
      {children}
    </StyledAppTab>
  );
};

export default ApplicationTab;
